import React, { memo, useState } from "react";

import AccordionSelect from "../CommonDropdown/AccordionSelect";
import CommonCard from "src/components/Card/Card";

import SectionHeader from "./SectionHeader";
import { FIELD_ICONS, DocumentIcon } from "./icons";
import InfoBanner from "../InfoBanner";
import { getMetricColor, METRIC } from "src/components/MultiDateTimeCalendar/calendarUtils";

/*
 * Location -> Pay Request Type -> Pay Request Name -> Shift Type, as a
 * single-open accordion. Only one field's option list is expanded at a time.
 */
const ContractualDetailsSection = ({ fields = [], disabled = false, visibleError, onFieldBlur, isShiftContract = false }) => {
  // Same threshold-type colouring the calendar cells use: teal for quantity
  // (shift) contracts, blue for hours.
  const accentColor = getMetricColor({ value: isShiftContract ? METRIC.QUANTITY : METRIC.HOURS });
  const [openKey, setOpenKey] = useState(null);

  // Closing a field - whether by re-toggling it shut or by picking an option
  // - is what counts as "leaving" it, so that's the one place an error for
  // this field is allowed to start showing.
  const closeField = (key) => {
    setOpenKey((prev) => (prev === key ? null : prev));
    onFieldBlur?.(key);
  };

  return (
    <section className="add-pay-request__section">
      <CommonCard className="add-pay-request__card add-pay-request__card--flush">
        <SectionHeader title="Contractual Details" />
        {fields.map((field, index) => (
          <AccordionSelect
            key={field.key}
            label={field.label}
            icon={FIELD_ICONS[field.key] ?? <DocumentIcon size={40} />}
            options={field.options}
            selection={field.selection}
            disabled={disabled || field.disabled}
            required
            accentColor={accentColor}
            showDivider={index < fields.length - 1}
            expanded={openKey === field.key}
            onToggle={() => {
              if (disabled || field.disabled) return;
              if (openKey === field.key) closeField(field.key);
              else setOpenKey(field.key);
            }}
            onSelect={(item) => {
              field.onSelect(item);
              closeField(field.key);
            }}
          />
        ))}
      </CommonCard>
      <div className="add-pay-request__section-error">
        {visibleError && (
          <InfoBanner className={"custom-banner"} attach="bottom" variant="danger" text={visibleError} />
        )}
      </div>
    </section>
  );
};

export default memo(ContractualDetailsSection);
